import { useContext } from "react";

import { AdminStructureGeneralDataFormContext } from "./adminStructureGeneralDataForm.context.definition";

export const useAdminStructureGeneralDataFormContext = () => {
  const ctx = useContext(AdminStructureGeneralDataFormContext);
  if (!ctx) {
    throw new Error(
      "AdminStructureGeneralData components must be used within AdminStructureGeneralDataFormProvider",
    );
  }
  return ctx;
};
